import type React from 'react';
import { EvaluationMark } from '../../../-components/EvaluationMark';
import { EvaluationPassRate } from '../../../-components/EvaluationPassRate';
import styles from './index.module.scss';

const PASS_RATE_PERCENTAGE = 100;
const EVALUATION_ITEMS = [
  {
    id: '1',
    title: '実務での変化を振り返れたか',
    description:
      '受講前と比較して、実務における意識や行動の変化を具体的に言葉にすることができました。',
    isPassed: true,
  },
  {
    id: '2',
    title: '実践から気づきを得られたか',
    description:
      '実践を通じて得られた、あなたにとって重要な気づきを言語化し、学びを深めることができました。',
    isPassed: true,
  },
  {
    id: '3',
    title: '今後の新たな取り組みを具体化できたか',
    description:
      '気づきを踏まえ、今後の実務での具体的な取り組みを明確に定めることができました。',
    isPassed: true,
  },
];

export type EvaluationSummaryProps = {
  isEvaluated: boolean;
};

export const EvaluationSummary: React.FC<EvaluationSummaryProps> = ({
  isEvaluated,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleArea}>
          <span className={styles.subLabel}>評価項目ごとの達成率</span>
          <h3 className={styles.title}>振り返りロールプレイ</h3>
        </div>
        <div className={styles.scoreHeader}>
          <EvaluationPassRate
            score={isEvaluated ? PASS_RATE_PERCENTAGE : null}
            isActive={true}
          />
        </div>
      </div>

      <div className={styles.itemsContainer}>
        {EVALUATION_ITEMS.map((item) => (
          <div key={item.id} className={styles.item}>
            <div className={styles.itemContent}>
              <h4 className={styles.itemTitle}>{item.title}</h4>
              <p className={styles.itemDescription}>{item.description}</p>
            </div>
            <div className={styles.itemEvaluations}>
              <div className={styles.evaluationCell}>
                <EvaluationMark
                  isPassed={isEvaluated ? item.isPassed : null}
                  className={styles.icon}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
